module.exports = {
  langs: [
    { langcode: "en", langname: "English" },
    { langcode: "es", langname: "Spanish" },
  ],
  defaultLangcode: "en",
};
